import { LOCATION_CHANGE } from 'react-router-redux';
import createReducer from '../utils/createReducer';
import {
  FLASH_MESSAGE,
  FLASH_MESSAGE_RESET,
} from '../constants/actions';

const initialState = {
  header: null,
  message: null,
  list: [],
  icon: null,
  color: null,
  show: false,
  type: '',
  autoHideDuration: 5000,
};

export default createReducer(initialState, {
  [FLASH_MESSAGE]: (state, payload) => (
    Object.assign({}, state, {
      header: payload.header,
      message: payload.message,
      list: payload.list,
      icon: payload.icon,
      show: payload.show,
      color: payload.color,
      type: payload.type,
      autoHideDuration: payload.autoHideDuration,
    })
  ),
  [FLASH_MESSAGE_RESET]: () => (
    Object.assign({}, initialState)
  ),
  [LOCATION_CHANGE]: () => (
    Object.assign({}, initialState)
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/flash.js